import { primitive } from 'styles/constants';
export default {
  expandedAccordionActiveAccentColor: primitive.$fieryRed,
  expandedAccordionBackground: undefined,
  expandedAccordionFontWeight: 'normal',
  accordionHoverBackground: undefined,
  rowInversionBackgroundColor: primitive.$fieryRed,
  rowInversionTextColor: primitive.$mayoEggWhite,
  backgroundColor: primitive.$mayoEggWhite,
  imageWidgetCaptionAlign: 'left',
};
